import { defineMessages } from '@/i18n'

/** Тексты общих частей редакторов блоков (кнопки-ссылки). */
export const messages = defineMessages({
  ru: {
    buttonText: 'Текст кнопки',
    removeButton: 'Удалить кнопку',
    untitledBlocksPublish: 'Без названия кнопка заблокирует публикацию курса',
    httpsRequired: 'Нужна ссылка на https://…',
    buttons: 'Кнопки',
    add: 'Добавить',
    buttonsEmpty: 'Кнопка со ссылкой на внешний ресурс — например, на лендинг или оплату.',
  },
  en: {
    buttonText: 'Button text',
    removeButton: 'Remove button',
    untitledBlocksPublish: 'A button without text will block publishing the course',
    httpsRequired: 'The link must start with https://',
    buttons: 'Buttons',
    add: 'Add',
    buttonsEmpty: 'A button linking to an external resource — e.g. a landing page or checkout.',
  },
})
